// extracted by mini-css-extract-plugin
module.exports = {"root":"reserved-credits-label_root__7xCTq","reservedIcon":"reserved-credits-label_reservedIcon__I57qo"};